/**
 * Acordeones Descripción y Especificaciones (producto): animación altura con GSAP.
 * Sin GSAP, el <details> funciona con el comportamiento nativo.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bind(details) {
    if (!details || details.dataset.gsapDescriptionAccordion === '1') return;
    if (typeof gsap === 'undefined') return;

    var summary = details.querySelector('summary');
    var panel = details.querySelector('.product-info__accordion-panel');
    if (!summary || !panel) return;

    details.dataset.gsapDescriptionAccordion = '1';

    summary.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('a')) return;
        e.preventDefault();

        var opening = !details.open;
        var reduced = prefersReducedMotion();
        var toggleEl = details.querySelector('.product-info__accordion-toggle');

        function pulseToggle() {
          if (!toggleEl || reduced) return;
          gsap.fromTo(
            toggleEl,
            { scale: 0.88, opacity: 0.5 },
            { scale: 1, opacity: 1, duration: 0.38, ease: 'back.out(1.7)' }
          );
        }

        if (opening) {
          details.open = true;
          pulseToggle();
          if (reduced) {
            gsap.set(panel, { clearProps: 'height,overflow' });
            return;
          }
          gsap.killTweensOf(panel);
          gsap.set(panel, { height: 0, overflow: 'hidden' });
          gsap.to(panel, {
            height: 'auto',
            duration: 0.52,
            ease: 'power3.out',
            onComplete: function () {
              gsap.set(panel, { clearProps: 'height' });
              panel.style.overflow = 'visible';
            },
          });
        } else {
          pulseToggle();
          if (reduced) {
            details.open = false;
            return;
          }
          gsap.killTweensOf(panel);
          gsap.set(panel, { overflow: 'hidden' });
          var h = panel.offsetHeight;
          gsap.set(panel, { height: h });
          gsap.to(panel, {
            height: 0,
            duration: 0.4,
            ease: 'power3.inOut',
            onComplete: function () {
              details.open = false;
              gsap.set(panel, { clearProps: 'height' });
              panel.style.overflow = '';
            },
          });
        }
      },
      true
    );
  }

  function init(root) {
    var scope = root || document;
    scope
      .querySelectorAll('.product-info__accordion--description, .product-info__accordion--specs')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target);
  });
})();
